import styled, { withTheme } from "styled-components";
import DefaultTable, {
  ActionButtons,
  Line,
} from "../../ui-library/CustomTable/DefaultTable";
import React from "react";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import ActionsButton from "../StudyEntriesTable/ActionsButton/ActionsButton";

const ActionsButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

const ParticipantTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    participants,
    addParticipant,
    canViewParticipantPage,
    canCreateParticipant,
    canEditParticipant,
    canChangeStudyStatus,
    canViewStudyStatus,
    canViewPersonalData,
    canGenerateReport,
    canManageUsers,
    loading,
    fetchEntriesData,
    studyId,
    refreshData,
    canCreate24hRecall,
    canCreatePaperRecapture,
    fetchDailyTargetHistory,
  } = props;

  const defaultProps = {
    headers: [
      { label: "Site" },
      { label: "Participant ID" },
      { label: "Study Status" },
      { label: "" },
    ],
    hasSearch: true,
    haspagesizefilter: true,
    haspagination: true,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  return (
    <DefaultTable {...defaultProps} data-testid="participants-table">
      <ActionButtons>
        {canCreateParticipant && (
          <PrimaryButton
            data-testid="add-participant-btn"
            className="btn btn-sm me-2"
            onClick={addParticipant}
          >
            Add Participant
          </PrimaryButton>
        )}
      </ActionButtons>
      {participants?.map((participant, index) => (
        <Line key={index}>
          <span>{participant.site}</span>
          <span>{participant.userName}</span>
          <span>{participant.studyStatus}</span>
          <ActionsButtonContainer>
            <ActionsButton
              fetchReportEntriesData={fetchEntriesData}
              fetchDailyTargetHistory={fetchDailyTargetHistory}
              canChangeStudyStatus={canChangeStudyStatus}
              studyId={studyId}
              canViewStudyStatus={canViewStudyStatus}
              canEditParticipant={canEditParticipant}
              canGenerateReport={canGenerateReport}
              canManageUsers={canManageUsers}
              canViewParticipantPage={canViewParticipantPage}
              canViewPersonalData={canViewPersonalData}
              participant={participant}
              onRefreshData={refreshData}
              canCreate24hRecall={canCreate24hRecall}
              canCreatePaperRecapture={canCreatePaperRecapture}
            />
          </ActionsButtonContainer>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(ParticipantTable);
